
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/practice-areas/grandparent-rights",
      function () {
        return require("private-next-pages/practice-areas/grandparent-rights/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/practice-areas/grandparent-rights"])
      });
    }
  